export function safeStr(x: any) {
  const s = String(x ?? "").trim();
  return s || "";
}

export function fmtAge(d: any) {
  const y = Number(d?.ageYears ?? 0);
  const m = Number(d?.ageMonths ?? 0);
  if (!y && !m) return "—";
  return `${y}y ${m}m`;
}

export function fmtList(x?: any[]) {
  if (!Array.isArray(x) || x.length === 0) return "None";
  return x.map(String).filter(Boolean).join(", ");
}

// Date-only strings parse as UTC midnight, so formatting them in the
// viewer's zone shows the previous day for anyone west of UTC — pin
// those to UTC. Full datetimes already parse as viewer-local.
const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function fmtDate(x?: string) {
  if (!x) return "—";
  const d = new Date(x);
  if (Number.isNaN(d.getTime())) return x;
  return d.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...(DATE_ONLY_RE.test(x.trim()) ? { timeZone: "UTC" } : {}),
  });
}

export function fmtShortDate(x?: string) {
    if (!x) return "—";
    const d = new Date(x);
    if (Number.isNaN(d.getTime())) return x;
    return d.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      ...(DATE_ONLY_RE.test(x.trim()) ? { timeZone: "UTC" } : {}),
    });
}
